/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon24Solid = forwardRef('NetConnectRssIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.388 6.831a12 12 0 0 0-4.832-.823 1.5 1.5 0 0 1-.11-2.998 15 15 0 0 1 15.543 15.553 1.5 1.5 0 1 1-2.997-.113 12.001 12.001 0 0 0-7.604-11.619Z" }),
        React.createElement("path", { d: "M7.922 12.847a5.5 5.5 0 0 0-2.315-.333 1.5 1.5 0 0 1-.215-2.992 8.5 8.5 0 0 1 9.086 9.09 1.5 1.5 0 1 1-2.992-.216 5.5 5.5 0 0 0-3.564-5.55Z" }),
        React.createElement("path", { d: "M6 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
